import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { html, nothing } from 'lit';
import { getFieldEngineerById } from '../../api/scoped-queries.js';
import type { SmartTeamsFieldEngineer } from '../../db/index.js';

/**
 * A component that resolves a field engineer ID to their name.
 * Uses backend query for single FE lookup.
 */
export const FieldEngineerName = stateful(({ fieldEngineerId }: { fieldEngineerId?: string }) => {
  // Query single field engineer by ID (with permission check)
  const feQuery = useQuery(
    () =>
      fieldEngineerId ? getFieldEngineerById(fieldEngineerId)({ _id: 1, name: 1, email: 1 }) : Promise.resolve(null),
    [fieldEngineerId],
  );

  if (!fieldEngineerId) {
    return html`<span class="text-base-content/50">-</span>`;
  }

  if (feQuery.loading) {
    return html`<span class="loading loading-spinner loading-xs"></span>`;
  }

  const fe = feQuery.value as SmartTeamsFieldEngineer | null;

  if (!fe) {
    return html`<span class="text-base-content/50 text-xs">${fieldEngineerId}</span>`;
  }

  return html`
    <div class="flex flex-col">
      <span class="text-sm font-medium">${fe.name}</span>
      ${fe.email ? html`<span class="text-xs text-base-content/50">${fe.email}</span>` : nothing}
    </div>
  `;
});
